const Dimens = {
	tabBarHeight52: 52,
	carouselPeek80: 80,
	carouselPeek100: 100,
	tabBarHeightWeb75: 75,
	buttonHeight36: 36,
	buttonHeight48: 48,
	buttonHeight50: 50,
	flex0: 0,
	flex08: 0.8,
	flex1: 1,
	flex11: 1.1,
	aspectRatioSquare: 1,
	aspectRatio16By9: 16 / 9,
	aspectRatio2By1: 2,
	ratio25: 25 / 100,
	ratio40: 40 / 100,
	ratio50: 50 / 100,
	ratio54: 54 / 100,
	ratio85: 85 / 100,
	ratio87: 87 / 100,
	ratio95: 95 / 100,
	ratio100: 100 / 100,
	fontSize10: 10,
	fontSize11: 11,
	fontSize12: 12,
	fontSize13: 13,
	fontSize14: 14,
	fontSize15: 15,
	fontSize16: 16,
	fontSize17: 17,
	fontSize18: 18,
	fontSize19: 19,
	fontSize20: 20,
	fontSize21: 21,
	fontSize22: 22,
	fontSize23: 23,
	fontSize24: 24,
	fontSize28: 28,
	fontSize30: 30,
	fontSize32: 32,
	lineHeight12: 12,
	lineHeight16: 16,
	lineHeight17: 17,
	lineHeight18: 18,
	lineHeight20: 20,
	lineHeight21: 21,
	lineHeight22: 22,
	lineHeight23: 23,
	lineHeight24: 24,
	lineHeight25: 25,
	lineHeight30: 30,
	lineHeight32: 32,
	lineHeight38: 38,
	lineHeight40: 40,
	letterSpacing015: 0.15,
	letterSpacing060: 0.6,
	fontWeight400: 400 as const,
	fontWeight500: 500 as const,
	fontWeight600: 600 as const,
	fontWeight700: 700 as const,
	paddingMinus24: -24,
	paddingMinus20: -20,
	paddingMinus18: -18,
	paddingMinus9: -9,
	paddingMinus8: -8,
	paddingMinus5: -5,
	paddingMinus3: -3,
	paddingMinus2: -2,
	padding0: 0,
	padding1: 1,
	padding2: 2,
	padding3: 3,
	padding4: 4,
	padding5: 5,
	padding6: 6,
	padding8: 8,
	padding10: 10,
	padding12: 12,
	padding14: 14,
	padding15: 15,
	padding16: 16,
	padding17: 17,
	padding18: 18,
	padding20: 20,
	padding24: 24,
	padding25: 25,
	padding26: 26,
	padding28: 28,
	padding30: 30,
	padding32: 32,
	padding34: 34,
	padding37: 37,
	padding38: 38,
	padding40: 40,
	padding48: 48,
	padding50: 50,
	padding60: 60,
	padding75: 75,
	padding80: 80,
	gap2: 2,
	gap4: 4,
	gap5: 5,
	gap6: 6,
	gap8: 8,
	gap10: 10,
	gap12: 12,
	gap14: 14,
	gap15: 15,
	gap16: 16,
	gap18: 18,
	gap20: 20,
	gap24: 24,
	gap30: 30,
	size0: 0,
	size1: 1,
	size2: 2,
	size3: 3,
	size4: 4,
	size5: 5,
	size6: 6,
	size8: 8,
	size10: 10,
	size12: 12,
	size14: 14,
	size16: 16,
	size17: 17,
	size18: 18,
	size20: 20,
	size24: 24,
	size28: 28,
	size25: 25,
	size26: 26,
	size30: 30,
	size31: 31,
	size32: 32,
	size36: 36,
	size40: 40,
	size44: 44,
	size48: 48,
	size50: 50,
	size53: 53,
	size55: 55,
	size56: 56,
	size60: 60,
	size62: 62,
	size64: 64,
	size65: 65,
	size76: 76,
	size70: 70,
	size75: 75,
	size80: 80,
	size81: 81,
	size88: 88,
	size90: 90,
	size91: 91,
	size96: 96,
	size100: 100,
	size120: 120,
	size128: 128,
	size130: 130,
	size134: 134,
	size140: 140,
	size170: 170,
	size200: 200,
	size210: 210,
	size213: 213,
	size214: 214,
	size218: 218,
	size250: 250,
	size275: 275,
	size277: 277,
	size300: 300,
	size320: 320,
	size380: 380,
	size400: 400,
	size414: 414,
	size450: 450,
	size500: 500,
	size800: 800,
	iconSize8: 8,
	iconSize10: 10,
	iconSize12: 12,
	iconSize14: 14,
	iconSize16: 16,
	iconSize18: 18,
	iconSize19: 19,
	iconSize20: 20,
	iconSize21: 21,
	iconSize22: 22,
	iconSize24: 24,
	iconSize28: 28,
	iconSize30: 30,
	borderWidth0: 0,
	borderWidth1: 1,
	borderWidth2: 2,
	borderWidth10: 10,
	borderRadius2: 2,
	borderRadius3: 3,
	borderRadius4: 4,
	borderRadius5: 5,
	borderRadius6: 6,
	borderRadius7: 7,
	borderRadius8: 8,
	borderRadius10: 10,
	borderRadius12: 12,
	borderRadius16: 16,
	borderRadius20: 20,
	borderRadius25: 25,
	borderRadius99: 99,
	borderRadiusPill: 999,
	opacity0: 0 / 100,
	opacity4: 4 / 100,
	opacity5: 5 / 100,
	opacity10: 10 / 100,
	opacity16: 16 / 100,
	opacity20: 20 / 100,
	opacity38: 38 / 100,
	opacity50: 50 / 100,
	opacity75: 75 / 100,
	opacity80: 80 / 100,
	opacity90: 90 / 100,
	opacity100: 100 / 100,
	scale0: 0 / 100,
	scale100: 100 / 100,
	zIndexBehind: -1,
	zIndexBase: 0,
	zIndexLifted: 1,
	zIndexRaised: 2,
	zIndexSticky: 5,
	zIndexHeader: 10,
	zIndexOverlay: 20,
	zIndexModal: 999,
	zIndexStickyHeader: 1000,
	zIndexOverlayHigh: 9999,
	zIndexOverlayHighest: 99999,
	elevation0: 0,
	elevation2: 2,
	elevation5: 5,
	elevation10: 10,
	elevation24: 24,
	swipeCloseVelocity800: 800,
	animationDelay40: 40,
	animationDuration0: 0,
	animationDuration100: 100,
	animationDuration250: 250,
	animationDuration300: 300,
	animationDuration500: 500,
	animationDuration800: 800,
	animationOffset25: 25,
	rotateMinus45: -45,
	rotate0: 0,
	rotate45: 45,
	rotate90: 90,
};

export default Dimens;
